export const IMAGES = {
  heroFood: "/images/hotbox-steak.jpg",
  cafeStorefront: "/images/cafe-storefront.jpg",
  hotboxGrid: "/images/hotbox-grid.jpg",
  hotboxSteak: "/images/hotbox-steak.jpg",
  hotboxChicken: "/images/hotbox-chicken.jpg",
  hotboxRamen: "/images/hotbox-ramen.jpg",
  prepBowls: "/images/prep-bowls.jpg",
  hotboxBowl: "/images/hotbox-bowl.jpg",
  soupBowl: "/images/soup.jpg",
  riceBowl: "/images/rice-bowl.jpg",
  greensPlate: "/images/greens.jpg",
  fruitPlatter: "/images/fruit-platter.jpg",
  citrusClapperboard: "/images/clapperboard-citrus.jpg",
  botanicalFern: "/images/fern-dark.jpg",
};

// Single source of truth for business contact details, address and opening hours.
// Update these values once and they change across the whole site (footer, café page,
// contact page and search-engine structured data).
export const CONTACT = {
  email: "info@root2shoot.com",
  phoneDisplay: "07413 027418",
  phoneHref: "tel:+447413027418",
  whatsapp: "https://wa.me/447413027418",
  phoneInternational: "+44 7413 027418",
  addressLines: ["Studio House, Battersea Road,", "Stockport, Greater Manchester"],
  postcode: "SK4 3EA",
  street: "Studio House, Battersea Road",
  locality: "Stockport",
  region: "Greater Manchester",
  hoursWeekday: "Mon – Fri · 8:00 – 15:00",
  hoursWeekend: "Sat & Sun · Closed",
  openingHoursSchema: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: "08:00",
    closes: "15:00",
  },
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/cafe", label: "Sustainable Café", testid: "nav-link-cafe" },
  { to: "/catering", label: "Film & TV Catering", testid: "nav-link-catering" },
  { to: "/our-story", label: "Our Story & Team", testid: "nav-link-story" },
  { to: "/sustainability", label: "Sustainability", testid: "nav-link-sustainability" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

export const MARQUEE_ITEMS = [
  "Low-Waste Kitchen",
  "Farm to Set",
  "Community Rooted",
  "Good Food, Brighter Futures",
  "No Single-Use Plastic",
  "Cooked with Soul",
  "We Bring the Food, Not the Kitchen",
  "People, Planet, Plates",
];

export const CHAPTERS = [
  {
    number: "01",
    title: "Zero-Waste Philosophy",
    body: "Every peel, stem and crust has a second act. Surplus can become staff meals, trimmings become stocks, and what remains feeds compost and food-rescue routes where practical.",
  },
  {
    number: "02",
    title: "On-Time, On-Budget, On-Set",
    body: "A crew that eats well shoots well. We build catering around production reality: early call times, night shoots and last-minute location moves.",
  },
  {
    number: "03",
    title: "Community & Brighter Futures",
    body: "Root2Shoot aims to employ, train and mentor people from our neighbourhood. Every catering contract helps create opportunities, support future apprenticeships and build a more inclusive, sustainable industry.",
  },
];

export const PACKAGES = [
  {
    tier: "essential",
    number: "Package 01",
    name: "Essential",
    price: "£18.50",
    priceNote: "per person",
    tagline: "A straightforward package for productions looking for a dependable, well-catered service with a complete price.",
    image: "/images/package-essential.jpg",
    poster: "/images/poster-essential.jpg",
    imageAlt: "Fresh-baked breakfast tartlets from the Root2Shoot kitchen",
    includes: [
      { icon: "bell", title: "Hot breakfast rolls", body: "With halal, vegan, gluten free and dairy free options available." },
      { icon: "leaf", title: "Two seasonal main courses", body: "One to be either meat or fish, with halal available. Served with seasonal vegetables and a choice of carbohydrate, such as rice, potatoes or pasta." },
      { icon: "cake", title: "Selection of cold desserts", body: "Vegan & gluten-free can be catered for as per your direction." },
      { icon: "box", title: "Hotboxing & compostable disposables", body: "Every package includes hotboxing and compostable disposables. It is a complete price." },
    ],
  },
  {
    tier: "enhanced",
    number: "Package 02",
    name: "Enhanced",
    price: "£22.50",
    priceNote: "per person",
    tagline: "A step up for productions wanting more choice around breakfast and dessert, with a wider selection and added extras.",
    image: "/images/hotbox-grid.jpg",
    poster: "/images/poster-enhanced.jpg",
    imageAlt: "A lineup of branded Root2Shoot hotboxes ready for delivery to a film or TV production",
    includes: [
      { icon: "bell", title: "Hot breakfast rolls", body: "With halal, vegan, gluten free and dairy free options available." },
      { icon: "croissant", title: "Cereals, warmed pastries, yogurt & fruit compote", body: "A selection of cereals, warmed pastries and yogurt with fruit compote, with dairy free / vegan options available. Fresh juices included." },
      { icon: "leaf", title: "Two seasonal main courses", body: "One to be either meat or fish, with halal available. Served with seasonal vegetables and a choice of carbohydrates, such as rice, potatoes or pasta." },
      { icon: "cake", title: "Selection of cold desserts", body: "Vegan & gluten-free options. A wider dessert selection can be catered for as per your direction." },
      { icon: "box", title: "Hotboxing & compostable disposables", body: "Every package includes hotboxing and compostable disposables. It is a complete price." },
    ],
  },
  {
    tier: "luxury",
    number: "Package 03",
    name: "Luxury",
    price: "£27.00",
    priceNote: "per person",
    tagline: "Our most premium package, with creative, high-quality menus using seasonal, locally sourced ingredients. Ideal for feature crews, high-end productions and special events.",
    image: "/images/package-luxury.jpg",
    poster: "/images/poster-luxury.jpg",
    imageAlt: "Pan-seared fish with asparagus, radish and dill — plated-style presentation from Root2Shoot's Luxury package",
    includes: [
      {
        icon: "bell",
        title: "Breakfast warm rolls",
        body: "With greens and various fillings from traditional bacon and egg to hashbrowns and spinach.",
        sub: { title: "Additional breakfast items", body: "Fresh fruit salad, granola and yoghurt pots, vegan chia seed pots, boiled eggs and fresh fruit juices." },
      },
      { icon: "leaf", title: "Lunch", body: "Meat, fish and vegan options, all with seasonal vegetables and a choice of carbohydrate." },
      { icon: "cake", title: "Fresh, homemade desserts", body: "Either cold or hot, as well as a fruit platter." },
      { icon: "box", title: "Hotboxing & compostable disposables", body: "Every package includes hotboxing and compostable disposables. It is a complete price." },
    ],
  },
];

export const SERVICE_PROMISES = [
  "Hotboxing & disposables",
  "Professional & friendly team",
  "Delivered fresh & ready to serve",
  "Flexible service options",
  "Transparent pricing",
];

export const EXTRA_SERVICES = [
  { id: "on-set", title: "On-Set Service", body: "Available as an additional service." },
  { id: "tea-coffee", title: "Tea & Coffee Station", body: "Available as an additional service or café tab during opening hours." },
];

export const FOOTPRINT = [
  { num: "01", id: "food", title: "Food", body: "Seasonal sourcing, plant-forward thinking, sensible purchasing and thoughtful menu design." },
  { num: "02", id: "local", title: "Locally Sourced", body: "We work with local growers and trusted suppliers to bring you the best quality ingredients where practical." },
  { num: "03", id: "waste", title: "Waste", body: "Repurposing, food-rescue partnerships, composting and practical waste reduction." },
  { num: "04", id: "service", title: "Service", body: "Permanent kitchen preparation, hotboxes, reusable kits and compostable serviceware." },
];

export const MENU_CATEGORIES = [
  {
    id: "breakfast",
    label: "Breakfast Menu",
    note: "",
    items: [
      {
        name: "Breakfast Bap",
        price: "from £4.95",
        detail: "A traditional floured bap with your choice of filling.",
        choices: [
          { label: "Choose your filling", options: ["Bacon — £5.90", "Sausage — £5.95", "Vegan Sausage — £4.95"] },
        ],
        extras: ["Add a fried egg +£1.50", "Add artisan bread +£1.00"],
        dietary: ["Vegan option available"],
        tags: [],
      },
      {
        name: "Full English",
        price: "£9.95",
        detail: "",
        includes: ["1 egg", "Bacon", "Sausage", "Black pudding", "Beans", "Mushrooms", "Tomatoes", "Hash brown"],
        footnote: "Includes bread & butter or toast.",
        extras: ["Add a warmed artisan roll +£1.00"],
        tags: [],
      },
      {
        name: "Belly Buster Breakfast",
        price: "£12.95",
        detail: "For those with a serious appetite!",
        includes: ["2 eggs", "2 bacon", "2 sausages", "2 black pudding", "Beans", "Mushrooms", "Tomatoes", "Hash browns"],
        footnote: "Includes bread & butter or toast.",
        extras: ["Add a warmed artisan roll +£1.00"],
        tags: [],
      },
      {
        name: "Vegetarian Breakfast",
        price: "£8.95",
        detail: "",
        includes: ["1 egg", "Veggie sausage", "Beans", "Mushrooms", "Tomatoes", "Hash brown", "Pan-fried greens"],
        footnote: "Includes bread & butter or toast.",
        extras: ["Add a warmed artisan roll +£1.00"],
        dietary: ["Vegetarian"],
        tags: ["V"],
      },
      {
        name: "Vegan Breakfast",
        price: "£8.95",
        detail: "",
        includes: ["2 vegan sausages", "Beans", "Mushrooms", "Tomatoes", "Hash browns", "Pan-fried greens", "Edamame bean guacamole"],
        footnote: "Includes vegan bread & spread or toast.",
        extras: ["Add a warmed artisan roll +£1.00"],
        dietary: ["Vegan"],
        tags: ["VG"],
      },
      {
        name: "All About Eggs Bap",
        price: "£7.95",
        detail: "Two fried eggs and melted cheese, served in a ciabatta.",
        choices: [
          { label: "With your choice of", options: ["Chipotle chilli salsa", "Sriracha mayo"] },
        ],
        tags: [],
      },
      {
        name: "Smoked Salmon, Rocket & Cream Cheese",
        price: "£8.50",
        detail: "Smoked salmon with dill oil and cream cheese, finished with fresh lemon and rocket.",
        choices: [
          { label: "Served in your choice of", options: ["Ciabatta", "Muffin"] },
        ],
        extras: ["Add spinach +£0.50"],
        tags: [],
      },
      {
        name: "Shakshuka Eggs",
        price: "£8.95",
        detail: "Middle Eastern flavours of sumac and za'atar folded into scrambled eggs with fresh rocket and a garnish, served with warmed artisan bread.",
        tags: [],
      },
      {
        name: "Cheese on Toast",
        price: "£6.50",
        detail: "Proper melted cheese on thick-cut artisan toasted bread.",
        extras: ["Add bacon +£1.50", "Add mushrooms +£1.50", "Add onions +£1.00"],
        dietary: ["Vegetarian"],
        tags: ["V"],
      },
      {
        name: "Homemade Nut-Free Granola",
        price: "£7.50",
        detail: "Homemade granola baked with maple syrup and coconut MCT oil, with roasted seeds.",
        choices: [
          { label: "Served with your choice of", options: ["Fresh milk", "Oat milk"] },
        ],
        extras: ["Add Greek yoghurt +£1.50", "Add vegan yoghurt +£1.50", "Add fruit compote +£1.00"],
        tags: ["NF"],
      },
      {
        name: "Fresh Fruit Salad",
        price: "£6.50",
        detail: "Fresh seasonal fruit with our homemade roasted omega seed mix and maple syrup.",
        extras: ["Add Greek yoghurt +£1.50", "Add vegan yoghurt +£1.50", "Add granola +£1.50", "Add fruit compote +£1.00"],
        tags: [],
      },
    ],
  },
  {
    id: "lunch",
    label: "Lunch Menu",
    note: "All breads are freshly supplied by a local bakery",
    items: [
      {
        name: "Soup of the Day",
        price: "£6.00",
        detail: "Homemade soup, made fresh daily, served with artisan bread or a warmed artisan roll.",
        extras: ["Add cheese on toast +£3.50"],
        footnote: "Check our specials board for today's flavour.",
        tags: [],
      },
      {
        group: "Mains",
        name: "Ciabatta Rolls",
        price: "£7.75",
        detail: "Freshly filled and served with salad garnish and chips.",
        choices: [
          { label: "Choose your filling", options: ["Tuna Mayo", "Chicken Mayo", "Cheese"] },
          { label: "Choose your bread", options: ["Artisan bread of the day", "Ciabatta", "White sliced loaf"] },
        ],
        extras: ["Add extra filling +£1.50", "Add salad +£1.00"],
        tags: [],
      },
      {
        group: "Mains",
        name: "Gammon, Egg & Chips",
        price: "£10.95",
        detail: "Locally sourced gammon steak.",
        choices: [
          { label: "Served with your choice of", options: ["Fried egg", "Griddled pineapple ring"] },
          { label: "And your choice of", options: ["Fat-cut chips", "Creamy mashed potatoes"] },
        ],
        footnote: "Homemade onion gravy optional.",
        tags: [],
      },
      {
        group: "Mains",
        name: "Steak Pie",
        price: "£10.95",
        detail: "Homemade steak pie made with locally sourced beef.",
        choices: [
          { label: "Served with your choice of", options: ["Creamy mashed potatoes", "Fat-cut chips"] },
        ],
        extras: ["Add peas +£1.00"],
        footnote: "Homemade onion gravy optional.",
        tags: [],
      },
      {
        group: "Mains",
        name: "Sausage, Mash & Onion Gravy",
        price: "£9.95",
        detail: "Locally sourced pork sausages with creamy mashed potatoes, served with peas and homemade onion gravy.",
        footnote: "Onion gravy optional.",
        tags: [],
      },
      {
        group: "Mains",
        name: "Homemade Hearty Homity-Style Cheese Pie",
        price: "£8.50",
        detail: "Homemade hearty Homity-style cheese pie, made using a delicious mix of cheeses. Served with a salad garnish.",
        choices: [
          { label: "And your choice of", options: ["Chips", "Mash"] },
        ],
        extras: ["Add peas +£1.50"],
        footnote: "Onion gravy optional.",
        tags: [],
      },
      {
        group: "Mains",
        name: "Traditional Chilli",
        price: "£9.95",
        detail: "Our traditional heart-warming chilli. Our beef is sourced locally from Red Tractor-approved suppliers.",
        choices: [
          { label: "Made with your choice of", options: ["Vegan", "Locally sourced beef"] },
          { label: "Served with", options: ["Rice", "Chips", "Mash"] },
        ],
        extras: ["Add cheese +£1.00", "Add salad +£1.25"],
        tags: ["VG option"],
      },
    ],
  },
  {
    id: "sandwiches",
    label: "Gourmet Sandwiches",
    note: "All breads are freshly supplied by a local bakery",
    items: [
      {
        name: "Gourmet Fish Finger Sandwich",
        price: "£10.95",
        detail: "Crispy gourmet fish fingers with iceberg lettuce, sliced tomato and homemade tartare sauce. Served with salad garnish and fat chips.",
        choices: [
          { label: "Choose your bread", options: ["Warmed artisan bread from a local bakery", "White sliced loaf"] },
        ],
        tags: [],
      },
      {
        name: "BLT",
        price: "£10.95",
        detail: "Smoked bacon, crisp iceberg lettuce and sliced tomato. Served with salad garnish and fat chips.",
        choices: [
          { label: "With your choice of", options: ["Vegan Mayo", "Sriracha Mayo", "Pink Sauce"] },
          { label: "Choose your bread", options: ["Warmed artisan bread from a local bakery", "White sliced loaf"] },
        ],
        tags: [],
      },
      {
        name: "Warmed Artisan Hunter's Chicken",
        price: "£10.95",
        detail: "A warmed artisan roll from a local bakery, filled with layers of tender chicken and BBQ sauce, oozing with melted cheese. Served with salad garnish and fat chips.",
        tags: [],
      },
      {
        name: "Warmed Artisan Mediterranean Vegetable Roll",
        price: "£9.95",
        detail: "A warmed artisan roll from a local bakery, stuffed with roasted Mediterranean vegetables tossed in our homemade nut-free, dairy-free pesto. Finished with rocket and home-pickled red onion. Served with salad garnish and fat chips.",
        choices: [
          { label: "Choose your filling", options: ["Mozzarella", "Homemade hummus (VG)"] },
        ],
        dietary: ["Vegan option available with hummus"],
        tags: ["VG option"],
      },
    ],
  },
  {
    id: "drinks",
    label: "Drinks",
    note: "",
    items: [
      { group: "Fresh Coffee", name: "Americano", price: "£3.00", detail: "Bean-to-cup fresh coffee.", tags: [] },
      { group: "Fresh Coffee", name: "Espresso", price: "£3.00", detail: "", tags: [] },
      { group: "Fresh Coffee", name: "Latte", price: "£4.10", detail: "", tags: [] },
      { group: "Fresh Coffee", name: "Cappuccino", price: "£4.10", detail: "", tags: [] },
      {
        group: "Milkshakes",
        name: "Milkshakes",
        price: "£4.00",
        detail: "",
        choices: [
          { label: "Choose your flavour", options: ["Vanilla", "Chocolate", "Strawberry", "Banana", "Protein"] },
          { label: "Choose your milk", options: ["Dairy milk", "Oat milk"] },
        ],
        extras: ["Add syrups +£1.50"],
        tags: [],
      },
      { group: "Tea", name: "Cup of Tea", price: "£3.00", detail: "", choices: [{ label: "Choose your milk", options: ["Dairy milk", "Oat milk"] }], tags: [] },
      { group: "Tea", name: "Pot of Tea", price: "£3.50", detail: "", choices: [{ label: "Choose your milk", options: ["Dairy milk", "Oat milk"] }], tags: [] },
      { group: "Tea", name: "Pot of Tea for Two", price: "£3.50", detail: "", choices: [{ label: "Choose your milk", options: ["Dairy milk", "Oat milk"] }], tags: [] },
      {
        group: "Freshly Chilled Juices",
        name: "Freshly Chilled Juices",
        price: "£3.95",
        detail: "",
        choices: [{ label: "Choose from", options: ["Orange", "Cranberry", "Apple"] }],
        tags: [],
      },
      { group: "Cold Drinks", name: "Cold Drinks", price: "", detail: "Selection of cold drinks, including water, priced individually.", tags: [] },
    ],
  },
];

export const TEAM = [
  {
    name: "Kevin",
    initials: "KE",
    role: "Founder & Head Chef",
    photo: "/images/team-kevin.jpg",
    tags: ["Birdwatcher", "DJ", "Club Biscuit"],
    bio: "A proud Stockport lad, avid birdwatcher and DJ who has played across the UK, Europe and Asia — Kevin also runs Club Biscuit, his regular night championing emerging DJ talent in Stockport. When health challenges pushed him to rethink his relationship with food around 15 years ago, the committed meat eater went vegetarian and discovered a whole new way of cooking. Practical, direct and quietly funny, he believes actions speak louder than words.",
  },
  {
    name: "Kaytie",
    initials: "KA",
    role: "Chef · Forager · Co-founder",
    photo: "/images/team-kaytie.jpg",
    tags: ["Forager", "Grower", "Plant-Forward"],
    bio: "Kaytie grew up where the North Devon countryside meets the sea, with seasonal food and wild ingredients always part of life. Vegetarian since fourteen, she's spent years exploring plant-forward cooking — happiest when foraging, growing Lion's Mane mushrooms, or finding new ways food can nourish both people and the planet. The team's proud tree hugger, and happy to own the title.",
  },
  {
    name: "Harvey",
    initials: "HA",
    role: "The Next Generation",
    photo: "/images/team-harvey.jpg",
    tags: ["Hospitality Student", "DJ", "Team Carnivore"],
    bio: "Harvey, Kevin's nephew, is the next generation of Root2Shoot. Currently studying hospitality, he's curious, enthusiastic and always hungry to learn. He stands out through his willingness to get stuck in, ask questions and put new ideas into practice. Like his uncle, he's passionate about DJing and regularly plays at Club Biscuit. Harvey is excited to be part of Root2Shoot, and we're just as excited to watch him grow into the chef and person he's becoming.",
  },
];

export const TIMELINE = [
  { year: "The Seed", title: "A market stall & a big idea", body: "Root2Shoot began as Stock2Pot — a weekend stall named for our Stockport roots, selling soups made from produce local farms couldn't sell. The queue told us we were onto something." },
  { year: "First Call Sheet", title: "Our first film set", body: "A friend asked us to work on a film set — and we loved it! The next job they got, the crew asked for us by name." },
  { year: "Zero-Waste Milestone", title: "Closing the loop", body: "We made waste a design problem: compost partnerships, food rescue and using every ingredient properly became our operating system." },
  { year: "Today", title: "The cafe opens its doors", body: "The café became our home base — open to the public by day, and the permanent kitchen that feeds productions by night." },
];

export const VALUES = [
  { title: "People", body: "We hire locally, train people properly and treat them fairly. A business is only as healthy as the people inside it." },
  { title: "Planet", body: "Plant-forward menus, rescued produce, compostable everything, and suppliers we can name." },
  { title: "Plates", body: "None of it matters if the food isn't brilliant. Flavour first — sustainability is the standard, not the compromise." },
];
